import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import './TargetComponent.css';
import TargetButtonAreaComponent from './TargetButtonAreaComponent';
import TargetSearchComponent from './TargetSearchComponent';
import TargetListComponent from './TargetListComponent';
import TargetPopDownloadComponent from './TargetPopDownloadComponent';
import TargetPopSaveConditionsComponent from './TargetPopSaveConditionsComponent';
import TargetPopSearchConditionsComponent from './TargetPopSearchConditionsComponent';
import TargetPopSendExternalComponent from './TargetPopSendExternalComponent';
import TargetPopSendSalesforceComponent from './TargetPopSendSalesforceComponent';
import {
  setSystemLodingFLg,
  setInitMessage,
} from '../../actions/CommonAction';
import {
  getCompanySearchList,
  setDownloadRequestPopFlg,
  setTab,
  setInitSearchCondition,
  createSearchCondition,
  setSaveConditionPopFlg,
  setSearchConditionPopFlg,
  getTradeInfoMaster,
  setTargetListHeaderItem,
  setSendExternalPopFlg,
  setSendSalesforcePopFlg,
} from '../../actions/TargetAction';
import {
  TARGET_TAB,
  TARGET_TRADE_DIVISION_CODE,
} from '../../../common/const';

// ターゲット検索一覧の共通項目
export const HEADER_COLUMN_COMMON = [
  // 事業所無し
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '1', item_class: 'syogou', item_width: 35,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '1', item_class: 'jyuusyo', item_width: 65,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '2', item_class: 'syogou', item_width: 30,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '2', item_class: 'jyuusyo', item_width: 50,
  },
  {
    item_code: 'gyouusyu', item_name: '業種', item_category: '2', item_class: 'gyouusyu', item_width: 20,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '3', item_class: 'syogou', item_width: 30,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '3', item_class: 'jyuusyo', item_width: 50,
  },
  {
    item_code: 'jyuugyouinsuu', item_name: '従業員数', item_category: '3', item_class: 'jyuugyouinsuu', item_width: 20,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '4', item_class: 'syogou', item_width: 30,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '4', item_class: 'jyuusyo', item_width: 50,
  },
  {
    item_code: 'uriagedaka', item_name: '当期売上高', item_category: '4', item_class: 'uriagedaka', item_width: 20,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '5', item_class: 'syogou', item_width: 30,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '5', item_class: 'jyuusyo', item_width: 40,
  },
  {
    item_code: 'gyouusyu', item_name: '業種', item_category: '5', item_class: 'gyouusyu', item_width: 20,
  },
  {
    item_code: 'jyuugyouinsuu', item_name: '従業員数', item_category: '5', item_class: 'jyuugyouinsuu', item_width: 10,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '6', item_class: 'syogou', item_width: 30,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '6', item_class: 'jyuusyo', item_width: 40,
  },
  {
    item_code: 'gyouusyu', item_name: '業種', item_category: '6', item_class: 'gyouusyu', item_width: 20,
  },
  {
    item_code: 'uriagedaka', item_name: '当期売上高', item_category: '6', item_class: 'uriagedaka', item_width: 10,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '7', item_class: 'syogou', item_width: 30,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '7', item_class: 'jyuusyo', item_width: 40,
  },
  {
    item_code: 'jyuugyouinsuu', item_name: '従業員数', item_category: '7', item_class: 'jyuugyouinsuu', item_width: 10,
  },
  {
    item_code: 'uriagedaka', item_name: '当期売上高', item_category: '7', item_class: 'uriagedaka', item_width: 20,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '8', item_class: 'syogou', item_width: 25,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '8', item_class: 'jyuusyo', item_width: 30,
  },
  {
    item_code: 'gyouusyu', item_name: '業種', item_category: '8', item_class: 'gyouusyu', item_width: 20,
  },
  {
    item_code: 'jyuugyouinsuu', item_name: '従業員数', item_category: '8', item_class: 'jyuugyouinsuu', item_width: 10,
  },
  {
    item_code: 'uriagedaka', item_name: '当期売上高', item_category: '8', item_class: 'uriagedaka', item_width: 15,
  },
  // 事業所有り
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '9', item_class: 'syogou', item_width: 30,
  },
  {
    item_code: 'jigyosyo', item_name: '事業所', item_category: '9', item_class: 'jigyosyo', item_width: 20,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '9', item_class: 'jyuusyo', item_width: 50,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '10', item_class: 'syogou', item_width: 25,
  },
  {
    item_code: 'jigyosyo', item_name: '事業所', item_category: '10', item_class: 'jigyosyo', item_width: 20,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '10', item_class: 'jyuusyo', item_width: 40,
  },
  {
    item_code: 'gyouusyu', item_name: '業種', item_category: '10', item_class: 'gyouusyu', item_width: 15,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '11', item_class: 'syogou', item_width: 25,
  },
  {
    item_code: 'jigyosyo', item_name: '事業所', item_category: '11', item_class: 'jigyosyo', item_width: 20,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '11', item_class: 'jyuusyo', item_width: 40,
  },
  {
    item_code: 'jyuugyouinsuu', item_name: '従業員数', item_category: '11', item_class: 'jyuugyouinsuu', item_width: 15,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '12', item_class: 'syogou', item_width: 30,
  },
  {
    item_code: 'jigyosyo', item_name: '事業所', item_category: '12', item_class: 'jigyosyo', item_width: 20,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '12', item_class: 'jyuusyo', item_width: 35,
  },
  {
    item_code: 'uriagedaka', item_name: '当期売上高', item_category: '12', item_class: 'uriagedaka', item_width: 15,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '13', item_class: 'syogou', item_width: 25,
  },
  {
    item_code: 'jigyosyo', item_name: '事業所', item_category: '13', item_class: 'jigyosyo', item_width: 15,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '13', item_class: 'jyuusyo', item_width: 30,
  },
  {
    item_code: 'gyouusyu', item_name: '業種', item_category: '13', item_class: 'gyouusyu', item_width: 15,
  },
  {
    item_code: 'jyuugyouinsuu', item_name: '従業員数', item_category: '13', item_class: 'jyuugyouinsuu', item_width: 15,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '14', item_class: 'syogou', item_width: 20,
  },
  {
    item_code: 'jigyosyo', item_name: '事業所', item_category: '14', item_class: 'jigyosyo', item_width: 15,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '14', item_class: 'jyuusyo', item_width: 35,
  },
  {
    item_code: 'gyouusyu', item_name: '業種', item_category: '14', item_class: 'gyouusyu', item_width: 15,
  },
  {
    item_code: 'uriagedaka', item_name: '当期売上高', item_category: '14', item_class: 'uriagedaka', item_width: 15,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '15', item_class: 'syogou', item_width: 25,
  },
  {
    item_code: 'jigyosyo', item_name: '事業所', item_category: '15', item_class: 'jigyosyo', item_width: 20,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '15', item_class: 'jyuusyo', item_width: 30,
  },
  {
    item_code: 'jyuugyouinsuu', item_name: '従業員数', item_category: '15', item_class: 'jyuugyouinsuu', item_width: 10,
  },
  {
    item_code: 'uriagedaka', item_name: '当期売上高', item_category: '15', item_class: 'uriagedaka', item_width: 15,
  },
  {
    item_code: 'syogou', item_name: '商号漢字', item_category: '16', item_class: 'syogou', item_width: 20,
  },
  {
    item_code: 'jigyosyo', item_name: '事業所', item_category: '16', item_class: 'jigyosyo', item_width: 15,
  },
  {
    item_code: 'jyuusyo', item_name: '所在地', item_category: '16', item_class: 'jyuusyo', item_width: 25,
  },
  {
    item_code: 'gyouusyu', item_name: '業種', item_category: '16', item_class: 'gyouusyu', item_width: 15,
  },
  {
    item_code: 'jyuugyouinsuu', item_name: '従業員数', item_category: '16', item_class: 'jyuugyouinsuu', item_width: 10,
  },
  {
    item_code: 'uriagedaka', item_name: '当期売上高', item_category: '16', item_class: 'uriagedaka', item_width: 15,
  },
];

/**
 * ターゲット画面全体
 */
class TargetComponent extends Component {
  componentDidMount() {
    // Google Analytics
    window.gtagPageview();
  }

  componentWillUnmount() {
    const { setInitMessageAct } = this.props;
    setInitMessageAct();
  }

  /**
  * ターゲット検索
  */
  searchClick = async () => {
    const {
      setSystemLodingFLgAct,
      createSearchConditionAct,
      getCompanySearchListAct,
      setTabAct,
      getTradeInfoMasterAct,
      setTargetListHeaderItemAct,
      targetListHeaderItem,
    } = this.props;
    setSystemLodingFLgAct(true);
    // 画面で選択した検索条件からパラメータを作成し一時保存領域に設定
    const ret = createSearchConditionAct();
    if (ret) {
      // 検索条件が設定されている場合、検索処理実行
      await getCompanySearchListAct();
      setTabAct(TARGET_TAB.TAB_LIST);

      if (!targetListHeaderItem || targetListHeaderItem.length === 0) {
        // ターゲット検索一覧の共通項目の取得（二重取りしないようディープコピー）
        const headerItem = JSON.parse(JSON.stringify(HEADER_COLUMN_COMMON));
        // お客様取引情報一覧項目の取得
        const retTradeResult = await getTradeInfoMasterAct(TARGET_TRADE_DIVISION_CODE.RESULT);
        if (retTradeResult && retTradeResult.additional_list) {
          // お客様取引情報の一覧項目をヘッダ項目変数に追加
          retTradeResult.additional_list.map((additional) => {
            const h = additional;
            h.item_class = 'additionalitem';
            h.item_width = 30;
            headerItem.push(h);
            return false;
          });
        }
        setTargetListHeaderItemAct(headerItem);
      }
    }

    setSystemLodingFLgAct(false);
  }

  /**
 * タブ切り替え
 */
  tabClick = (newTab) => {
    const { setTabAct } = this.props;
    setTabAct(newTab);
  }

  /**
 * 条件クリア
 */
  clear = () => {
    // 一時保存領域条件クリア
    const { setInitSearchConditionAct } = this.props;
    setInitSearchConditionAct();
  }

  /**
 * ダウンロードオプションポップアップ
 */
  togglePopup = () => {
    const { setDownloadRequestPopFlgAct, downloadRequestPopFlg } = this.props;
    setDownloadRequestPopFlgAct(!downloadRequestPopFlg);
  }

  /**
  * 検索条件保存ポップアップを画面に表示
  */
  showSaveConditionPop = () => {
    const {
      setSaveConditionPopFlgAct,
      saveConditionPopFlg,
      createSearchConditionAct,
    } = this.props;

    const ret = createSearchConditionAct('1');
    if (ret) {
      setSaveConditionPopFlgAct(!saveConditionPopFlg);
    }
  }

  /**
  * 検索条件一覧ポップアップを画面に表示
  */
  showSearchConditionPop = () => {
    const { setSearchConditionPopFlgAct, searchConditionPopFlg } = this.props;
    setSearchConditionPopFlgAct(!searchConditionPopFlg);
  }

  /**
* Salesforce送信確認ポップアップ
*/
  sendSalesforcePopup = () => {
    const { setSendSalesforcePopFlgAct, sendSalesforcePopFlg } = this.props;
    setSendSalesforcePopFlgAct(!sendSalesforcePopFlg);
  }

  /**
 * 外部送信確認ポップアップ
 */
  sendExternalPopup = () => {
    const { setSendExternalPopFlgAct, sendExternalPopFlg } = this.props;
    setSendExternalPopFlgAct(!sendExternalPopFlg);
  }

  render() {
    const {
      tab,
      searchCondition,
      searchConditionPopFlg,
      saveConditionPopFlg,
    } = this.props;

    return (
      <div className="targetCompany">
        <div className="targetHeader">
          <div className="tabGroup">
            <Button
              className={[
                'tab',
                tab === TARGET_TAB.TAB_SEARCH ? 'selected' : null,
              ].join(' ')}
              onClick={() => {
                this.tabClick(TARGET_TAB.TAB_SEARCH);
              }}
              tabIndex="-1"
            >
              検索設定
            </Button>
            <Button
              className={[
                'tab',
                tab === TARGET_TAB.TAB_LIST ? 'selected' : null,
                searchCondition ? null : 'disabled',
              ].join(' ')}
              onClick={() => {
                this.tabClick(TARGET_TAB.TAB_LIST);
              }}
              disabled={!searchCondition}
              tabIndex="-1"
            >
              検索結果
            </Button>
          </div>
          <TargetButtonAreaComponent
            tab={tab}
            togglePopup={this.togglePopup}
            searchClick={this.searchClick}
            clear={this.clear}
            showSaveConditionPop={this.showSaveConditionPop}
            showSearchConditionPop={this.showSearchConditionPop}
            sendExternalPopup={this.sendExternalPopup}
            sendSalesforcePopup={this.sendSalesforcePopup}
          />
        </div>
        <div className="container">
          {tab === TARGET_TAB.TAB_SEARCH
            && (
              <TargetSearchComponent
                tabClick={() => this.tabClick(TARGET_TAB.TAB_LIST)}
                tab={tab}
                togglePopup={this.togglePopup}
                searchClick={this.searchClick}
                clear={this.clear}
                showSaveConditionPop={this.showSaveConditionPop}
                showSearchConditionPop={this.showSearchConditionPop}

              />
            )}
          {tab === TARGET_TAB.TAB_LIST
            ? <TargetListComponent /> : ''}
        </div>
        <TargetPopDownloadComponent />
        <TargetPopSendExternalComponent />
        <TargetPopSendSalesforceComponent />
        {saveConditionPopFlg && (
          <TargetPopSaveConditionsComponent />
        )}
        {searchConditionPopFlg && (
          <TargetPopSearchConditionsComponent />
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    tab: state.target.tab,
    downloadRequestPopFlg: state.target.downloadRequestPopFlg,
    saveConditionPopFlg: state.target.saveConditionPopFlg,
    searchConditionPopFlg: state.target.searchConditionPopFlg,
    searchCondition: state.target.searchCondition,
    targetListHeaderItem: state.target.targetListHeaderItem,
    sendExternalPopFlg: state.target.sendExternalPopFlg,
    sendSalesforcePopFlg: state.target.sendSalesforcePopFlg,
  }),
  (dispatch) => ({
    getCompanySearchListAct: (str) => dispatch(getCompanySearchList(str)),
    setDownloadRequestPopFlgAct: (bool) => dispatch(setDownloadRequestPopFlg(bool)),
    setTabAct: (tab) => dispatch(setTab(tab)),
    setInitSearchConditionAct: () => dispatch(setInitSearchCondition()),
    createSearchConditionAct: (string) => dispatch(createSearchCondition(string)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setSaveConditionPopFlgAct: (bool) => dispatch(setSaveConditionPopFlg(bool)),
    setSearchConditionPopFlgAct: (bool) => dispatch(setSearchConditionPopFlg(bool)),
    getTradeInfoMasterAct: (divisionCode) => dispatch(getTradeInfoMaster(divisionCode)),
    setTargetListHeaderItemAct: (object) => dispatch(setTargetListHeaderItem(object)),
    setSendExternalPopFlgAct: (bool) => dispatch(setSendExternalPopFlg(bool)),
    setSendSalesforcePopFlgAct: (bool) => dispatch(setSendSalesforcePopFlg(bool)),
  }),
)(TargetComponent);
